/**
 *  @project ICoFR PJB
 *  @author Ian Maulana on Tuesday, 20. August 2019
 *  @email ian_maulana@yahoo.com
 *  @description Custom axios instance to define config axios
 */

import axios from 'axios'
import store from '../../store/index'
import alert from '../helper/alert.helper'

const service = axios.create({
  timeout: 3000000,
  transformResponse: [
    function (data) {
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data)
        } catch (e) { /* Ignore */ }
      }

      return data
    }
  ]
})

// logging response request on development environment
service.interceptors.request.use(function (config) {
  if (config.showLoader !== false) {
    store.commit('loader/pending')
  }
  return config
}, function (error) {
  store.commit('loader/done')
  return Promise.reject(error)
})

// Add a response interceptor
service.interceptors.response.use(function (response) {
  store.commit('loader/done')
  if (response.data.status === 400) {
    alert.warning(response.data.message)
  }
  return response
}, function (error) {
  if (error.response.data.status === 500) {
    alert.failed('Terjadi Kesalahan pada server!')
  }
  store.commit('loader/done')
  return Promise.reject(error)
})

export default service
